import { render, staticRenderFns } from "./TransferNftFormModal.vue?vue&type=template&id=5b8fd44b&scoped=true&"
import script from "./TransferNftFormModal.vue?vue&type=script&lang=js&"
export * from "./TransferNftFormModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferNftFormModal.vue?vue&type=style&index=0&id=5b8fd44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8fd44b",
  null
  
)

export default component.exports